var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-input"},[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{class:[
      'switch',
      {
        on: _vm.value,
        off: !_vm.value,
      } ],on:{"click":_vm.onEvent}},[_c('div',{class:['indicator']})])])}
var staticRenderFns = []

export { render, staticRenderFns }